/**
 * @ngInject
 */
function videoResizer () {

    function onWindowResize () {
        iframe.style.height = el.offsetWidth/ratio+"px";

    }

    function link (scope, elem, attrs) {
        el = elem[0];
        if (el.classList.contains('video')) {
            iframe = el.querySelector('iframe');
            ratio = iframe.getAttribute("width") / iframe.getAttribute("height");
            // console.log(ratio);
            window.addEventListener('resize', _.debounce(onWindowResize, 250));
            onWindowResize();
        }
    }

    var el, iframe, ratio;

    return {
        restrict : 'A',
        link : link
    };
}